/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_App_StoreInputs */

const en_downloads_app_store = /** @type {(inputs: Downloads_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download on the App Store`)
};

const es_downloads_app_store = /** @type {(inputs: Downloads_App_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar en App Store`)
};

/**
* | output |
* | --- |
* | "Download on the App Store" |
*
* @param {Downloads_App_StoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_app_store = /** @type {((inputs?: Downloads_App_StoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_App_StoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_app_store(inputs)
	return en_downloads_app_store(inputs)
});